var map = {
  "./cs.json": [
    "P7",
    [
      "xx"
    ]
  ],
  "./en.json": [
    "wG",
    [
      "u2"
    ]
  ],
  "./pl.json": [
    "ceR",
    [
      "ef"
    ]
  ],
  "./ru.json": [
    "khi",
    [
      "yt"
    ]
  ],
  "./tr.json": [
    "fO",
    [
      "9h"
    ]
  ],
  "./ja.json": [
    "rSa",
    [
      "tx1"
    ]
  ],
  "./zh.json": [
    "OA",
    [
      "s1u"
    ]
  ],
  "./pt-br.json": [
    "qiy",
    [
      "cp"
    ]
  ],
  "./de.json": [
    "Hn",
    [
      "h7"
    ]
  ],
  "./es.json": [
    "hSv",
    [
      "vc"
    ]
  ],
  "./fr.json": [
    "VH3",
    [
      "bo"
    ]
  ],
  "./it.json": [
    "AG",
    [
      6
    ]
  ],
  "./ko.json": [
    "XNS",
    [
      "17j"
    ]
  ],
  "./pt.json": [
    "X3y",
    [
      "1f"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "aW";
module.exports = __rspack_async_context;
